<template>
  <modal :modal-key="'result_of_add_on_game_modal'" :class-style="'modal--welcomeback modal--zero-balance'"
                 @close="goToHomePage()">
    <template slot="body">
      <div v-if="addOnGameData.success">
        <div class="modal__header modal_addon_game">
          <h1>{{ getTranslations.post_game_add_on_success }}</h1>
          <img class="addon_game_icon" src="static/images/face_won.png" alt="">
        </div>
        <div class="modal__body modal_body_addon_game">
          <div class="new_game_buttons_section ">

            <h2>{{ getTranslations.post_game_add_on_congrats }}</h2>
            <button type="button"  @click="goToHomePage()" class="btn2 btn2--small_for_addgame btn2--std">{{ getTranslations.post_game_new_game }}</button>
            <br> <br>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="modal__header modal_addon_game">
          <h1>{{ getTranslations.post_game_add_on_fail_no }}</h1>
          <img class="addon_game_icon" src="static/images/face_lost.png" alt="">
        </div>
        <div class="modal__body modal_body_addon_game">
          <div class="new_game_buttons_section ">

            <h2>{{ getTranslations.post_game_add_on_fail_almost }}</h2>
            <button type="button"  @click="goToHomePage()" class="btn2 btn2--small_for_addgame btn2--std">{{ getTranslations.post_game_new_game }}</button>
            <br> <br>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
/* eslint no-console: "off" */
/* postgame_lost_no_points_lost.html --> NO_WIN_LOSE */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Modal from '../../modals/shared/GenericModal';

export default {
  name: 'result-of-add-on-game',
  components: { Modal },
  created() {
    console.log('in Result of Add on Game created hook');
    if (!this.addOnGameData.gameId) this.$router.push('/home');
    // eslint-disable-next-line
    const payload = { gameId: this.addOnGameData.gameId, successful: this.addOnGameData.success, correctAnswers: this.addOnGameData.correctAnswers, adjustPenaltyPoints: 'false' };
    this.updateDGamesForAddOn(payload);
  },
  beforeDestroy() {
    this.resetAddOnGameData();
  },
  methods: {
    ...mapActions('profile', [
      'updateDGamesForAddOn',
    ]),
    ...mapMutations('game', [
      'resetAddOnGameData',
    ]),
    goToHomePage() {
      this.$router.push('/home');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'addOnGameData',
    ]),
    ...mapState('common', [
      'facebookFunctionality',
      'addOnMode',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongame/ResultOfAddOnGame.vue